import { createI18n } from 'vue-i18n';

// Import des modules de traduction
import adminEn from './en/admin.json';
import apiEn from './en/api.json';
import commonEn from './en/common.json';
import homeEn from './en/home.json';
import adminFr from './fr/admin.json';
import apiFr from './fr/api.json';
import commonFr from './fr/common.json';
import homeFr from './fr/home.json';

// Fonction utilitaire pour fusionner les objets de traduction
function mergeTranslations(...objects: Record<string, any>[]): Record<string, any> {
  return objects.reduce((merged, obj) => {
    return { ...merged, ...obj };
  }, {});
}

// Assemblage des traductions françaises
const fr = mergeTranslations(
  commonFr,
  { home: homeFr },
  { admin: adminFr },
  { api: apiFr }
);

// Assemblage des traductions anglaises
const en = mergeTranslations(
  commonEn,
  { home: homeEn },
  { admin: adminEn },
  { api: apiEn }
);

// Configuration i18n
export const i18n = createI18n({
  legacy: false,
  locale: 'fr', // langue par défaut
  fallbackLocale: 'en',
  messages: {
    fr,
    en
  }
});

// Export des traductions individuelles pour utilisation directe si nécessaire
export { adminEn, adminFr, apiEn, apiFr, commonEn, commonFr, en, fr, homeEn, homeFr };
